import { Blur, Remote } from "@/api/loaderRemote";
import useClickOutside from "@/hooks/useClickOutside";
import { Facebook, Linkedin, Twitter } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import React, { useRef, useState } from "react";

const BlogCard = ({ blog }) => {
  const refOne = useRef(null);
  const refTwo = useRef(null);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsDropdownOpen((prev) => !prev);
  };

  useClickOutside([refOne, refTwo], () => setIsDropdownOpen(false));

  const url = `https://villavagonu.com${blog.url}`;
  const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
  const twitterLink = `https://x.com/intent/post?text=${url}`;
  
  return (
    <div className="flex flex-col">
      <div className="p-3 border-b rounded-t-2xl border-[#EDF2F7] fill-white drop-shadow-[0_4px_74px_rgba(0,0,0,0.05)] bg-white">
        <div className="relative">
          <Link href={blog.url} title={blog.title} prefetch={false}>
            <Image
              src={blog.resim}
              width={252}
              height={168}
              loader={Remote}
              blurDataURL={Blur(blog.resim)}
              alt={blog.title}
              className="object-cover w-full rounded-lg h-36"
            />
          </Link>
          <button
            ref={refOne}
            type="button"
            onClick={toggleDropdown}
            className="flex items-center justify-center w-[34px] h-[34px] bg-white rounded-full absolute top-1 right-1"
          >
            <Image src="/icons/share.svg" width="14" height="14" alt="Share" />
          </button>
          {isDropdownOpen && (
            <div
              ref={refTwo}
              className="absolute top-[40px] right-0 bg-white border border-gray-200 rounded-md shadow-md z-10"
            >
              <ul className="text-sm text-gray-700">
                <li className="px-4 py-2 cursor-pointer hover:bg-gray-100">
                  <Link
                    href={facebookLink}
                    target="_blank"
                    className="flex items-center gap-1 text-xs"
                  >
                    <Facebook size={20} />
                    Facebook
                  </Link>
                </li>
                <li className="px-4 py-2 cursor-pointer hover:bg-gray-100">
                  <Link
                    href={twitterLink}
                    target="_blank"
                    className="flex items-center gap-1 text-xs"
                  >
                    <Twitter size={20} /> Twitter
                  </Link>
                </li>
                <li className="px-4 py-2 cursor-pointer hover:bg-gray-100">
                  <a
                    href="#"
                    target="_blank"
                    className="flex items-center gap-1 text-xs"
                  >
                    <Linkedin size={20} /> LinkedIn
                  </a>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
      <Link
        href={blog.url}
        title={blog.title}
        className="h-[60px] flex py-3 px-2 rounded-b-2xl fill-white drop-shadow-[0_4px_74px_rgba(0,0,0,0.05)] bg-white"
      >
        <span className="text-xs font-semibold leading-normal text-center text-black">
          {blog.title}
        </span>
      </Link>
    </div>
  );
};

export default BlogCard;
